import type { PatchCaseUpdateBody } from '@packages/clients';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { buildFailCodeUpdateBody } from '../helpers';

/** Parameters for clearing fail code fields on a techline case. */
export type ClearFailCodeParams = {
    /** The case number to clear fail codes on. */
    caseNumber: string;

    /** The retailer number associated with the case. */
    retailerNumber: string | undefined;

    /** The username making the update. */
    username: string;

    /** The VIN associated with the case. */
    vin: string | undefined;
};

/**
 * Clear the fail code fields on a techline case by setting all four
 * fields (repairCode, failCode, section, subSection) to empty strings.
 * This is a distinct operation from updating fail codes; it resets
 * the fields entirely rather than setting them to new values.
 */
export class ClearFailCode extends StsBackendOperation {
    /**
     * Build an empty fail code payload and persist it via the API.
     *
     * @param params - the identity fields for the case to clear
     */
    async exec(params: ClearFailCodeParams): Promise<void> {
        const updateBody = buildFailCodeUpdateBody({
            ...params,
            failCodeData: {
                failCode: '',
                repairCode: '',
                section: '',
                subSection: '',
            },
        }) as PatchCaseUpdateBody;
        await this.client.updateCase({ updateBody });
    }
}
